import React, { useEffect, useState } from 'react';
import ArrowLeft from '@/components/customercenter-ui/svgs/arrowLeft';
import ArrowRight from '@/components/customercenter-ui/svgs/arrowRight';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/customSelect/customSelect';

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const [selectedPage, setSelectedPage] = useState(currentPage);

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handlePageChange = (page: any) => {
    setSelectedPage(page);
    onPageChange(page);
  };

  const handlePrevPage = () => {
    const prevPage = selectedPage - 1;
    if (prevPage >= 1) {
      handlePageChange(prevPage);
    }
  };

  const handleNextPage = () => {
    const nextPage = selectedPage + 1;
    if (nextPage <= totalPages) {
      handlePageChange(nextPage);
    }
  };
  useEffect(() => {
    setSelectedPage(currentPage);
  }, [currentPage]);

  return (
    <div className="flex items-center">
      <button onClick={handlePrevPage} disabled={selectedPage === 1}>
        <ArrowLeft />
      </button>
      <Select
        // defaultValue={selectedPage.toString()}
        onValueChange={(value) => handlePageChange(parseInt(value))}
        value={selectedPage.toString()}
      >
        <SelectTrigger className="w-auto gap-4 border-0 py-6 text-sm font-normal">
          <SelectValue defaultValue={selectedPage} />
        </SelectTrigger>
        <SelectContent className="bg-white">
          <SelectGroup>
            {pageNumbers.map((page) => (
              <SelectItem key={page} value={page.toString()}>
                Page {page} of {totalPages}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <button onClick={handleNextPage} disabled={selectedPage === totalPages}>
        <ArrowRight />
      </button>
    </div>
  );
};

export default Pagination;
